// extracted by mini-css-extract-plugin
export var chip = "_al-0";
export var filterDropdown = "_al-5";
export var filterItem = "_al-6";
export var icon = "_al-1";
export var removeButton = "_al-3";
export var removeIcon = "_al-4";
export var separator = "_al-2";